// Find icons here:
// https://iconsax-react.pages.dev/
// https://react-icons.github.io/react-icons

import {
  Activity,
  Add,
  AddSquare,
  ArchiveBox,
  ArrangeHorizontalSquare,
  ArrowDown2,
  ArrowLeft2,
  ArrowRight,
  ArrowRight2,
  ArrowRotateLeft,
  ArrowRotateRight,
  ArrowSquareLeft,
  ArrowUp,
  ArrowUp2,
  Briefcase,
  Calendar2,
  Chart2,
  Code,
  Coffee,
  Command,
  Copy,
  Diagram,
  DocumentText1,
  Edit2,
  EmojiHappy,
  ExportCurve,
  ExportSquare,
  Eye,
  EyeSlash,
  Flashy,
  GalleryImport,
  Global,
  Gift,
  HambergerMenu,
  Hierarchy,
  Hierarchy3,
  IconProps,
  Import,
  ImportSquare,
  InfoCircle,
  Judge,
  Logout,
  Kanban,
  LanguageSquare,
  Link,
  Link2,
  Link21,
  Lock1,
  LogoutCurve,
  Magicpen,
  Maximize1,
  Maximize3,
  MedalStar,
  MessageQuestion,
  Moon,
  More,
  MouseCircle,
  Note1,
  Notification,
  Play,
  Profile,
  Profile2User,
  ProfileCircle,
  ProfileRemove,
  Receipt,
  Record,
  RecordCircle,
  RepeateMusic,
  Scissor,
  Send,
  Routing,
  Setting2,
  Share,
  Shuffle,
  SidebarLeft,
  SidebarRight,
  Sms,
  Star,
  Stop,
  Sun1,
  Task,
  TaskSquare,
  Timer1,
  Trash,
  UserEdit,
  UserSquare,
  Video,
} from 'iconsax-react'
import React from 'react'
import { BsPinAngle, BsPinAngleFill } from 'react-icons/bs'
import { IoFootsteps, IoFootstepsOutline } from 'react-icons/io5'
import {
  LuCloudLightning,
  LuCloudRain,
  LuCloudSun,
  LuCloudSunRain,
  LuInfo,
  LuRainbow,
  LuSun,
} from 'react-icons/lu'
import { FaUsers } from 'react-icons/fa'
import { FiCheck, FiHelpCircle, FiMove, FiShare2, FiX } from 'react-icons/fi'
import { IoSearchOutline } from 'react-icons/io5'
import {
  PiClipboardTextFill,
  PiCompassFill,
  PiSparkleFill,
  PiUsersThreeFill,
} from 'react-icons/pi'
import { RiMapPinUserLine } from 'react-icons/ri'
import { TbCircles, TbMessageBolt, TbUserPlus } from 'react-icons/tb'

export const AddIcon = Add
export const AddMemberIcon = TbUserPlus
export const ArchiveIcon = ArchiveBox
export const ApiIcon = Code
export const BillingIcon = Receipt
export const AppsIcon = ArrangeHorizontalSquare
export const ArrowRightIcon = ArrowRight
export const ArrowUpIcon = ArrowUp
export const BackIcon = ArrowSquareLeft
export const CancelIcon = ArrowRotateLeft
export const CenterIcon = Maximize1
export const CheckIcon = FiCheck
// Rejecting a tension (REU-02 B). Validating reuses CheckIcon above rather than
// getting a name of its own: two exported names for one glyph only make the
// next reader wonder which to pick. A plain cross says "set aside" without
// dramatising — a rejected tension is not destroyed.
export const RejectIcon = FiX
export const ChecklistIcon = Task
export const ChevronDownIcon = ArrowDown2
export const ChevronLeftIcon = ArrowLeft2
export const ChevronRightIcon = ArrowRight2
export const ChevronUpIcon = ArrowUp2
export const CircleIcon = RecordCircle
export const CircleLinkIcon = Link2
export const CircleParentLinkIcon = Link
export const CirclePick = MouseCircle
// Marks a node holding sub-circles, as opposed to a leaf role. Mirrors the org
// chart, where packages/graph draws the same Tabler glyph inline (CirclesGlyph).
// Named after it rather than "CirclesIcon", one letter from CircleIcon above.
export const CirclesGlyphIcon = TbCircles
// The filters of the role picker (#123, chosen in recette 28/09).
export const PerimeterMeetingCircleIcon = MouseCircle
export const PerimeterMyRolesIcon = ProfileCircle
export const PerimeterMyCirclesIcon = TbCircles
export const PerimeterAllIcon = Global
export const CopyIcon = Copy
export const CreateIcon = AddSquare
export const CurrentMemberIcon = UserSquare
export const DarkThemeIcon = Moon
export const DecisionIcon = Judge
export const DecisionsIcon = Judge
export const DeleteIcon = Trash
export const DownloadIcon = Import
export const EditIcon = Edit2
export const EmailIcon = Sms
export const ExportCircleIcon = GalleryImport
export const ExportIcon = ExportSquare
export const FileIcon = DocumentText1
export const HelpIcon = MessageQuestion
export const HideIcon = EyeSlash
export const ImportIcon = ImportSquare
export const IndicatorsIcon = Diagram
export const InfoTooltipIcon = FiHelpCircle
export const KanbanIcon = Kanban
export const LanguageIcon = LanguageSquare
export const LightThemeIcon = Sun1
export const LinkIcon = Link21
export const LogIcon = ArrowRotateLeft
export const LogoutIcon = LogoutCurve
export const LogsIcon = ArrowRotateLeft
export const MagicIcon = Magicpen
export const MarkUnreadIcon = EyeSlash
export const MaximizeIcon = Maximize3
export const MeetingAvatarIcon = FaUsers
export const MeetingIcon = Calendar2
export const MeetingRecurringIcon = RepeateMusic
export const MeetingsIcon = Calendar2
export const MemberIcon = Profile
export const MembersIcon = Profile2User
export const MyRolesIcon = RiMapPinUserLine
export const MenuIcon = HambergerMenu
export const MoreIcon = More
export const MoveIcon = ArrowRight
export const NewsIcon = Activity
export const NoteIcon = Note1
export const NotificationIcon = Notification
export const OrgChartIcon = MouseCircle
export const PanIcon = FiMove
export const PinIcon = BsPinAngle
export const PinnedIcon = BsPinAngleFill
// Les trois forfaits de la vitrine (ADM07-D10). Une seule idée qui progresse :
// le temps qu'on prête, l'organigramme qu'on dessine seul, le réseau de gens
// qui l'anime. Les trois glyphes sont bâtis sur des cercles reliés, ce qui en
// fait une famille sans qu'on ait à l'expliquer.
// Distincts des SubscriptionPlan* plus bas, qui appartiennent aux forfaits
// Stripe de l'amont et restent avec le parcours de paiement caché (ADM-D7).
export const PlanTrialIcon = Timer1
export const PlanSoloIcon = Hierarchy3
// Même glyphe que ShareIcon, autre intention : ici c'est le collectif, pas le
// partage. Précédent maison : HideIcon et MarkUnreadIcon partagent EyeSlash.
export const PlanGroovIcon = Share
export const PlayIcon = Play
export const PollIcon = Chart2
export const PrivacyIcon = Lock1
// CONF-02 : les trois niveaux de visibilité. Le cadenas reste celui de l'ancien
// « privé », qu'il remplace ; les cercles pour le niveau Cercle ; le globe pour
// toute l'organisation.
export const VisibilityRoleIcon = Lock1
export const VisibilityCircleIcon = TbCircles
export const VisibilityOrgIcon = Global
export const RandomIcon = Shuffle
export const ReactionIcon = EmojiHappy
export const RemoveMemberIcon = ProfileRemove
export const RestoreIcon = ArchiveBox
export const RoleIcon = Record
export const RotateLeftIcon = ArrowRotateLeft
export const RotateRightIcon = ArrowRotateRight
export const SeparateIcon = Scissor
export const SearchIcon = (props: IconProps) => (
  <IoSearchOutline size={props.size || 24} />
)
export const SendIcon = Send
export const SettingsIcon = Setting2
export const SidebarLeftIcon = SidebarLeft
export const SidebarRightIcon = SidebarRight
export const ShareIcon = Share
// Sharing a compte rendu outside its circle (#115): the classic share icon,
// three circles in a network (Yohan, 26/09/2026)
export const MeetingSummaryShareIcon = FiShare2
export const ShortcutsIcon = Command
export const ShowIcon = Eye
export const StopIcon = Stop
export const SubscriptionIcon = Star
export const SubscriptionPlanBusiness = Briefcase
export const SubscriptionPlanFree = Gift
export const SubscriptionPlanStartup = Coffee
export const TaskIcon = TaskSquare
export const TasksIcon = TaskSquare
export const TasksListIcon = Task
// A tension is a message carrying a charge, hence the bolt inside the bubble.
// Tabler draws at stroke-width 2 where the rest of the app (iconsax) draws at
// 1.5, so the width is pinned here — otherwise this icon reads heavier than
// every icon next to it.
const ThreadBubbleIcon = (props: IconProps) => (
  <TbMessageBolt size={props.size || 24} strokeWidth={1.5} />
)
export const ThreadIcon = ThreadBubbleIcon
export const ThreadsIcon = ThreadBubbleIcon

// The two meeting steps that hold threads. Both from iconsax, like their
// neighbours in the "add a step" menu.
export const MeetingStepThreadsIcon = Flashy
export const MeetingStepThreadsGovernanceIcon = Hierarchy

// Opening and closing rounds. The weather stands for the inclusion because that
// is the word people use for it; the door for the déclusion, which reads as its
// pair without needing an explanation.
//
// The weather comes from Lucide rather than iconsax: iconsax's version draws
// the rays differently, and this is the one Yohan asked for. Lucide draws at
// stroke-width 2, so the width is pinned to match the rest of the menu, same as
// the thread bubble above.
export const MeetingStepInclusionIcon = (props: IconProps) => (
  <LuCloudSun size={props.size || 24} strokeWidth={1.5} />
)
export const MeetingStepDeclusionIcon = Logout
// Routing draws two places joined by a winding path — chosen on a board of
// eight candidates (G2-D16) to name the STEP TYPE in the meeting's step menu,
// among iconsax siblings where a footprint does not exist.
//
// ⚠️ It no longer marks the composer's button: since 11/08/2026 that button
// wears the footprint like every other place a next step appears (Yohan). The
// rule is now simple — the footprint IS the next step, wherever one is shown or
// created; Routing only names the step type in a menu of iconsax icons. This
// revises the "one feature, one sign" of G2-D16, which had paired the composer
// button with the step type rather than with the thing it creates.
export const MeetingStepNextStepsIcon = Routing
// The footprint marks a step itself, wherever it is listed — board, thread,
// personal page. Routing stays for the MENU entry, where it names the step type
// among iconsax siblings; the two never sit side by side. Ionicons draws at a
// different weight, so the size is pinned like the weather icon above.
// Outline, not the solid face: repeated on every line of a board, the filled
// footprint drew more attention than the steps themselves (Yohan, 11/08/2026).
export const NextStepItemIcon = (props: { size?: number; style?: any }) => (
  <IoFootstepsOutline size={props.size || 24} style={props.style} />
)
// Sidebar entry (D28). ⚠️ Special case: the sidebar drives iconsax icons with
// `variant={isActive ? 'Bold' : 'Linear'}`, and iconsax has NO footprint at
// all — so the switch is done by hand here, filled when active, outlined
// otherwise. The `variant` prop is swallowed rather than forwarded, Ionicons
// would not know what to do with it.
export const NextStepsNavIcon = ({ variant }: { variant?: string }) =>
  variant === 'Bold' ? (
    <IoFootsteps size={24} />
  ) : (
    <IoFootstepsOutline size={24} />
  )
export const UploadIcon = ExportCurve
export const UserInfoIcon = UserEdit
export const VacantCircle = InfoCircle
export const InfoIcon = InfoCircle
export const VisioIcon = Video
export const SuperAdminIcon = MedalStar

// The weather of a tension inside a meeting (#89). Lucide, like the inclusion
// icon above: it already draws the whole scale, so nothing was hand-drawn. Its
// stroke is pinned to 1.5 for the same reason as the others — Lucide draws at 2
// and would look heavier than the icons next to it.
//
// ⚠️ Shower is CloudSunRain, not CloudSun: CloudSun already names the inclusion
// step (the round where each person says their weather), and the two show on
// the same screen. Same family, two different signs.
const weatherIcon = (Icon: typeof LuCloudSun, name: string) => {
  const WeatherIcon = (props: { size?: number }) => (
    <Icon size={props.size || 20} strokeWidth={1.5} />
  )
  WeatherIcon.displayName = name
  return WeatherIcon
}

export const ThreadWeatherStormIcon = weatherIcon(
  LuCloudLightning,
  'ThreadWeatherStormIcon'
)
export const ThreadWeatherRainIcon = weatherIcon(
  LuCloudRain,
  'ThreadWeatherRainIcon'
)
export const ThreadWeatherShowerIcon = weatherIcon(
  LuCloudSunRain,
  'ThreadWeatherShowerIcon'
)
export const ThreadWeatherSunnySpellIcon = weatherIcon(
  LuSun,
  'ThreadWeatherSunnySpellIcon'
)
export const ThreadWeatherForecastIcon = weatherIcon(
  LuInfo,
  'ThreadWeatherForecastIcon'
)
// The rainbow only ever comes AFTER the rain: it marks a tension that was
// settled, never a cran of the scale (REU89-D14).
export const ThreadWeatherDoneIcon = weatherIcon(
  LuRainbow,
  'ThreadWeatherDoneIcon'
)

// Meeting step aids (#136): Facilitation, Secretary, Participants, Good to know
export const MeetingAidFacilitationIcon = PiCompassFill
export const MeetingAidSecretaryIcon = PiClipboardTextFill
export const MeetingAidParticipantsIcon = PiUsersThreeFill
export const MeetingAidKnowIcon = PiSparkleFill
